<template>
  <h4 class="h4">
    <slot></slot>
  </h4>
</template>

<script>
export default {
  name: 'Afh4'
}
</script>

<style lang="postcss" scoped>
.h4 {
  font-size: 16px;
  line-height: 24px;
  font-weight: 600;
  margin-bottom: 0;
  margin-top: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/AfH4.vue